export default __webpack_public_path__ + "static/media/download_ios.e81da3a7.png";